import { BADGE_TIERS } from '@nine/shared';
import { C, mix } from '../pix';
import { defineIconKind } from '../store';

/** Badge tablets by tier (1 iron … 4 gold). */
defineIconKind('badge', {
  label: 'ป้ายสำนัก',
  ids: () => BADGE_TIERS.map((b) => String(b.tier)),
  name: (id) => BADGE_TIERS.find((b) => String(b.tier) === id)?.name ?? id,
  tint: (id) => BADGE_TIERS.find((b) => String(b.tier) === id)?.color ?? C.steelMid,
  plate: 'none',
  fallback: (id) => ({
    draw: (p) => {
      const b = BADGE_TIERS.find((x) => String(x.tier) === id);
      const metal = b?.color ?? C.steelMid;
      const tier = b?.tier ?? 1;
      // Cord and tassel.
      p.line(16, 1, 16, 5, C.seal);
      p.rect(14, 27, 4, 2, C.seal);
      p.line(15, 29, 14, 31, C.seal).line(17, 29, 18, 31, C.seal);
      // The tablet: rounded top, inset face.
      p.ell(16, 9, 9, 5, metal);
      p.rect(7, 9, 18, 18, metal);
      p.rect(9, 10, 14, 15, mix(metal, '#24142c', 0.3));
      p.ell(16, 6, 2, 2, mix(metal, '#24142c', 0.5));
      // A sword mark and the rank's studs.
      p.rect(15, 11, 2, 8, mix(metal, C.white, 0.55));
      p.rect(13, 13, 6, 1, mix(metal, C.white, 0.55));
      for (let k = 0; k < tier; k++)
        p.rect(16 - tier * 2 + k * 4 + 1, 21, 2, 2, tier >= 4 ? C.white : C.goldLight);
    },
  }),
});
